import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ConfirmModal from '@/components/ConfirmModal';
import { useSubscriptionModalStore } from '@/store/useSubscriptionModalStore';
import { PATHS } from '@/router/paths';
import { trackEvent } from '@/utils/analytics';
import { EVENTS } from '@/utils/analyticsEvents';

const GlobalUpgradeModal: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isOpen, feature, context, hideModal } = useSubscriptionModalStore();

  useEffect(() => {
    if (isOpen) {
      trackEvent(EVENTS.UPGRADE_PROMPT_DISPLAYED, { feature, context });
    }
  }, [isOpen, feature, context]);

  const handleUpgrade = () => {
    trackEvent(EVENTS.UPGRADE_PROMPT_CLICKED, { feature, context });
    hideModal();
    navigate(PATHS.subscription, { state: { source: 'upgrade_prompt' } });
  };

  const handleCancel = () => {
    trackEvent(EVENTS.UPGRADE_PROMPT_DISMISSED, { feature, context });
    hideModal();
  };

  return (
    <ConfirmModal
      open={isOpen}
      icon="warning"
      iconBgColor="var(--yellow-10)"
      iconColor="var(--yellow-100)"
      title={t('global.upgradeModal.title')}
      description={t('global.upgradeModal.description')}
      confirmText={t('global.upgradeModal.upgrade')}
      cancelText={t('global.upgradeModal.cancel')}
      onConfirm={handleUpgrade}
      onCancel={handleCancel}
    />
  );
};

export default GlobalUpgradeModal;
